/**
 * セレクトボックス（v-select）の選択肢の識別キー（item-value）を生成するユーティリティ。
 *
 * Vuetify は item-value 未指定の場合、選択肢の表示名（item-title）を内部キーとして扱う。
 * 表示名は一意とは限らないため、同名の選択肢があると仮想スクロール時に表示が重複する。
 * 識別キーが単一のコードで表せる場合は item-value に項目名を直接指定し、
 * 複数のコードの組み合わせで一意になる場合は本ユーティリティを item-value に指定する。
 */

/** 識別キーの区切り文字（コードの境界を明確にし、連結による衝突を防ぐ） */
const KEY_SEPARATOR = '-';

/** 駅の識別キーの生成元 */
type StationKeySource = {
  /** 駅コード */
  stationCd: string;
  /** 社線駅サブコード */
  stationSubCd: string;
};

/** 代行利用者の識別キーの生成元 */
type DelegateUserKeySource = {
  /** 代行利用者所属JR駅コード */
  stationCd: string;
  /** 代行利用者所属社線駅サブコード */
  stationSubCd: string;
  /** 代行利用者コード */
  userCompanyCd?: string;
  /** 代行集配人コード */
  deliveryCompanyCd?: string;
};

/**
 * 駅の識別キーを取得する（駅コード + 社線駅サブコード）
 *
 * @param station 駅情報
 * @returns 識別キー
 */
export const getStationItemValue = (station?: StationKeySource): string => {
  if (!station) {
    return '';
  }
  return [station.stationCd, station.stationSubCd].join(KEY_SEPARATOR);
};

/**
 * 代行利用者の識別キーを取得する
 * （代行利用者所属JR駅コード + 代行利用者所属社線駅サブコード + 代行利用者コード + 代行集配人コード）
 *
 * @param delegateUser 代行利用者情報
 * @returns 識別キー
 */
export const getDelegateUserItemValue = (delegateUser?: DelegateUserKeySource): string => {
  if (!delegateUser) {
    return '';
  }
  return [
    delegateUser.stationCd,
    delegateUser.stationSubCd,
    delegateUser.userCompanyCd ?? '',
    delegateUser.deliveryCompanyCd ?? '',
  ].join(KEY_SEPARATOR);
};
